import React from "react";
import {
  EmployeePanel,
  LocationPanel,
  OperatingModelPanel,
  RevenuePanel,
  SavedSearchesPanel,
  TermsPanel,
} from "./filterPanels";
import NaturalLanguagePanel from "./NaturalLanguagePanel";
import { FILTER_IDS } from "./filterIds";

/**
 * Shared panel renderer for V2 popovers and V3 sidebar sections.
 * `onApply` commits the open panel and closes its menu/section.
 * Multi-select panels use compact SelectedChipsArea for selected values.
 */
export function renderFilterPanel(filterId, ctx) {
  const {
    filtersDisabled,
    debounceMultiSelectUpdates,
    onApply,
    termsInclude,
    setTermsInclude,
    termsExclude,
    setTermsExclude,
    industryChoices,
    industryInclude,
    setIndustryInclude,
    industryExclude,
    setIndustryExclude,
    locations,
    setLocations,
    locationChoices,
    revenueLowerBound,
    revenueUpperBound,
    setRevenueLowerBound,
    setRevenueUpperBound,
    employeesLowerBound,
    employeesUpperBound,
    setEmployeesLowerBound,
    setEmployeesUpperBound,
    naturalQuery,
    setNaturalQuery,
    savedSearchChoices,
    selectedSavedSearch,
    onSelectSavedSearch,
    onDeleteSavedSearch,
  } = ctx;

  switch (filterId) {
    case FILTER_IDS.TERMS:
      return (
        <TermsPanel
          termsInclude={termsInclude}
          setTermsInclude={setTermsInclude}
          termsExclude={termsExclude}
          setTermsExclude={setTermsExclude}
          disabled={filtersDisabled}
          onApply={onApply}
        />
      );
    case FILTER_IDS.INDUSTRY:
      return (
        <OperatingModelPanel
          industryChoices={industryChoices}
          industryInclude={industryInclude}
          setIndustryInclude={setIndustryInclude}
          industryExclude={industryExclude}
          setIndustryExclude={setIndustryExclude}
          disabled={filtersDisabled}
          onApply={onApply}
          debounceMultiSelectUpdates={debounceMultiSelectUpdates}
        />
      );
    case FILTER_IDS.LOCATION:
      return (
        <LocationPanel
          locations={locations}
          setLocations={setLocations}
          locationChoices={locationChoices}
          disabled={filtersDisabled}
          onApply={onApply}
          debounceMultiSelectUpdates={debounceMultiSelectUpdates}
        />
      );
    case FILTER_IDS.REVENUE:
      return (
        <RevenuePanel
          revenueLowerBound={revenueLowerBound}
          revenueUpperBound={revenueUpperBound}
          setRevenueLowerBound={setRevenueLowerBound}
          setRevenueUpperBound={setRevenueUpperBound}
          disabled={filtersDisabled}
          onApply={onApply}
        />
      );
    case FILTER_IDS.EMPLOYEE:
      return (
        <EmployeePanel
          employeesLowerBound={employeesLowerBound}
          employeesUpperBound={employeesUpperBound}
          setEmployeesLowerBound={setEmployeesLowerBound}
          setEmployeesUpperBound={setEmployeesUpperBound}
          disabled={filtersDisabled}
          onApply={onApply}
        />
      );
    case FILTER_IDS.NATURAL_LANGUAGE:
      return (
        <NaturalLanguagePanel
          naturalQuery={naturalQuery}
          setNaturalQuery={setNaturalQuery}
          onApply={onApply}
        />
      );
    case FILTER_IDS.SAVED_SEARCHES:
      return (
        <SavedSearchesPanel
          savedSearchChoices={savedSearchChoices}
          selectedSavedSearch={selectedSavedSearch}
          onSelectSavedSearch={onSelectSavedSearch}
          onDeleteSavedSearch={onDeleteSavedSearch}
        />
      );
    default:
      return null;
  }
}
